import {z} from '@hono/zod-openapi';

export const VoiceDebugErrorResponseSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    code: z.enum([
      'invalid-request',
      'unauthorized',
      'not-found',
      'invalid-profile',
      'unsupported-scenario',
      'conflict',
      'expired-session',
      'capacity-rejected',
      'budget-rejected',
      'provider-failure',
      'gateway-unavailable',
      'setup-timeout',
      'cursor-too-old',
    ]),
    message: z.string().min(1).max(256),
  })
  .strict()
  .openapi('VoiceDebugErrorResponseSchema');

export type VoiceDebugErrorResponse = z.infer<typeof VoiceDebugErrorResponseSchema>;
